module.exports = __webpack_public_path__ + "img/ikem.0995b0db.png";